import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  ref: "contentContainer",
  class: "content-container"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_icon = _resolveComponent("icon");
  const _component_standard_button = _resolveComponent("standard-button");
  const _component_w_tool_tip = _resolveComponent("w-tool-tip");
  return _openBlock(), _createElementBlock("div", {
    ref: "viewport",
    class: _normalizeClass(['panzoom-viewer-viewport', {
      'has-bottom-controls': _ctx.buttonsPosition === 'bottom-center'
    }])
  }, [_createElementVNode("div", _hoisted_1, [_renderSlot(_ctx.$slots, "default", {}, undefined, true)], 512), _createElementVNode("div", {
    class: _normalizeClass(['zoom-controls', _ctx.buttonsPosition])
  }, [_createVNode(_component_w_tool_tip, {
    text: _ctx.$t('panzoomViewer.zoomInTooltip'),
    placement: _ctx.zoomBtnTooltipPlacement
  }, {
    default: _withCtx(() => [_createVNode(_component_standard_button, {
      class: "zoom-btn",
      disabled: !_ctx.canZoomIn,
      outlined: true,
      onAction: _cache[0] || (_cache[0] = $event => _ctx.zoomIn())
    }, {
      default: _withCtx(() => [_createVNode(_component_icon, {
        icon: "magnify-plus-outline"
      })]),
      _: 1
    }, 8, ["disabled"])]),
    _: 1
  }, 8, ["text", "placement"]), _createVNode(_component_w_tool_tip, {
    text: _ctx.$t('panzoomViewer.zoomOutTooltip'),
    placement: _ctx.zoomBtnTooltipPlacement
  }, {
    default: _withCtx(() => [_createVNode(_component_standard_button, {
      class: "zoom-btn",
      disabled: !_ctx.canResetOrZoomOut,
      outlined: true,
      onAction: _cache[1] || (_cache[1] = $event => _ctx.zoomOut())
    }, {
      default: _withCtx(() => [_createVNode(_component_icon, {
        icon: "magnify-minus-outline"
      })]),
      _: 1
    }, 8, ["disabled"])]),
    _: 1
  }, 8, ["text", "placement"]), _createVNode(_component_w_tool_tip, {
    text: _ctx.$t('panzoomViewer.zoomResetTooltip'),
    placement: _ctx.zoomBtnTooltipPlacement
  }, {
    default: _withCtx(() => [_createVNode(_component_standard_button, {
      class: "zoom-btn",
      disabled: !_ctx.canResetOrZoomOut,
      outlined: true,
      onAction: _cache[2] || (_cache[2] = $event => _ctx.resetZoom())
    }, {
      default: _withCtx(() => [_createVNode(_component_icon, {
        icon: "arrow-collapse"
      })]),
      _: 1
    }, 8, ["disabled"])]),
    _: 1
  }, 8, ["text", "placement"]), _createVNode(_component_w_tool_tip, {
    text: _ctx.fullscreenTooltip,
    placement: _ctx.zoomBtnTooltipPlacement
  }, {
    default: _withCtx(() => [_createVNode(_component_standard_button, {
      class: "zoom-btn",
      outlined: true,
      onAction: _cache[3] || (_cache[3] = $event => _ctx.toggleFullscreen())
    }, {
      default: _withCtx(() => [_createVNode(_component_icon, {
        icon: _ctx.isFullscreen ? 'fullscreen-exit' : 'fullscreen'
      }, null, 8, ["icon"])]),
      _: 1
    })]),
    _: 1
  }, 8, ["text", "placement"])], 2)], 2);
}